import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const bancaAcoesAfirmativasRoutes: Routes = [
  {
    path: 'banca-acoes-afirmativas',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Banca - Ações afirmativas',
      breadcrumb: [{ label: 'Banca - Ações afirmativas', url: '/banca-acoes-afirmativas' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./banca-acoes-afirmativas-list/banca-acoes-afirmativas-list.component').then(
            (m) => m.BancaAcoesAfirmativasListComponent,
          ),
        data: {
          title: 'Listagem de Profissionais',
          roles: [Role.BANCA_ACOES_AFIRMATIVAS_CONSULTAR],
          breadcrumb: [{ label: 'Banca - Ações afirmativas', url: '/banca-acoes-afirmativas' }],
        },
      },
      {
        path: ':inscricaoCicloId',
        loadComponent: () =>
          import('./banca-acoes-afirmativas-detail/banca-acoes-afirmativas-detail.component').then(
            (m) => m.BancaAcoesAfirmativasDetailComponent,
          ),
        data: {
          title: 'Informações Documentais',
          roles: [Role.BANCA_ACOES_AFIRMATIVAS_CONSULTAR],
          breadcrumb: [
            { label: 'Banca - Ações afirmativas', url: '/banca-acoes-afirmativas' },
            { label: 'Informações Documentais' },
          ],
        },
      },
    ],
  },
];
